export class MinMaxBounds {
    min: number;
    max: number;

    constructor(min: number, max: number) {
        if (min > max) {
            throw new Error("Min value cannot be greater than max value.");
        }
        this.min = min;
        this.max = max;
    }

    clamp(value: number): number {
        return Math.max(this.min, Math.min(this.max, value));
    }

    get middle() {
        return (this.min + this.max) / 2;
    }
}
